import './style.css'
import World from './threeJsClass/World.js'
import createAnimationUi from './functions/animation.js'
import createTextureUi from './functions/texture.js'

document.getElementById('link1').href = "./favicon/apple-touch-icon.png"
document.getElementById('link2').href = "./favicon/favicon-32x32.png"
document.getElementById('link3').href = "./favicon/favicon-16x16.png"
document.getElementById('link4').href = "./favicon/site.webmanifest"

const world = new World()
const toggleButtonImage = document.getElementById('toggleButtonImage')
toggleButtonImage.src = './assets/cog.png'

// Panel Toggle Event
const uiButtons = document.getElementById('uiButtons')
const toggleButton = document.getElementById('toggleButton')
const ui = document.getElementById('ui')
let isPanelOpen = false
let isLandscape = false

toggleButton.addEventListener('click', () => {
  if(isPanelOpen){
    closeUi()
  }
  else{
    openUi()
  }
})

function openUi(){    
  isPanelOpen = true
  animateIcon(toggleButtonImage, './assets/cross.png')
  ui.style.transform = "translateX(0vw)"

  if (isLandscape){
    uiButtons.style.transform = `translateX(33vw)`
  }
  else{
    uiButtons.style.transform = `translateX(0vw)`
  }
}

function closeUi(){
  isPanelOpen = false

  uiButtons.style.transform = 'translateX(0px)'  
  animateIcon(toggleButtonImage, './assets/cog.png')

  if (isLandscape){
    ui.style.transform = 'translateX(-33vw)'
  }
  else{
    ui.style.transform = 'translateX(-100vw)'
  }
}

function refreshUi(){
  if(isPanelOpen){
    openUi()
  }
  else{
    closeUi()
  }
}

// Resize
window.addEventListener('resize', () => {
  resize()
})

function resize(){
  if(window.innerWidth > window.innerHeight){
    if(!isLandscape){
      isLandscape = true
      refreshUi()
    }
  }
  else {
    if(isLandscape){
      isLandscape = false
      refreshUi()
    }
  }
}

// Animation Ui
createAnimationUi(world)
createTextureUi(world)

// Toggle Ui
const animationDiv = document.getElementById('animation')
const textureDiv = document.getElementById('texture')

const animButton = document.getElementById('animButton')
const textureButton = document.getElementById('textureButton')

animButton.addEventListener('click', () => {
  toAnimation()
})

textureButton.addEventListener('click', () => {
  toTexture()
})

function toAnimation(){
  animButton.style.backgroundColor = "white"
  textureButton.style.backgroundColor = "transparent"

  animButton.style.color = "#1a1a1a"
  textureButton.style.color = "white"

  animationDiv.style.display = "block"
  textureDiv.style.display = "none"
}

function toTexture(){
  textureButton.style.backgroundColor = "white"
  animButton.style.backgroundColor = "transparent"

  textureButton.style.color = "#1a1a1a"
  animButton.style.color = "white"

  textureDiv.style.display = "block"
  animationDiv.style.display = "none"
}
toAnimation()

// === //
// Fly //
// === //
const flyMode = document.getElementById('flyMode')
const flyButtonImage = document.getElementById('flyButtonImage')
flyButtonImage.src = './assets/airplane.png'
let useFlyMode = false

const speedIcon = document.getElementById('speedIcon')
speedIcon.src = './assets/speedometer.png'

flyMode.addEventListener('click', () => {
  if(!useFlyMode){
    world.goFly()
    animateIcon(flyButtonImage, './assets/orbit.png')
  }
  else{
    world.goOrbit()
    animateIcon(flyButtonImage, './assets/airplane.png')
  }

  useFlyMode = !useFlyMode
})

function animateIcon(img, path){
  img.style.opacity = 0
  setTimeout(() => {
    img.src = path
    img.style.opacity = 1
  }, 250)
}

resize()